document.addEventListener('DOMContentLoaded', () => {
  // Redirect URL handling (reading ?return_url and backfilling the form's
  // checkout_url field) lives in assets/auth-redirect.js.

  // ========== Back button handling ==========
  const backButton = document.querySelector('.account-login-back-button');
  if (backButton) {
    const localeRoot = window._erj_.localeRoot();

    backButton.addEventListener('click', (e) => {
      e.preventDefault();
      const referrer = document.referrer;
      if (referrer && referrer.indexOf(window.location.hostname) !== -1) {
        window.history.back();
      } else {
        window.location.href = localeRoot;
      }
    });
  }

  // ========== Login/Register Form Toggle ==========
  const loginSection = document.getElementById('login-form-section');
  const registerSection = document.getElementById('register-form-section');
  const switchToRegisterLinks = document.querySelectorAll('[data-switch-to-register]');
  const switchToLoginLinks = document.querySelectorAll('[data-switch-to-login]');
  const clearLoginReturnUrlLinks = document.querySelectorAll('[data-clear-login-return-url]');

  if (!loginSection || !registerSection) return;

  const animateVisibleSection = (section) => {
    section.classList.remove('is-form-switching');
    void section.offsetWidth;
    section.classList.add('is-form-switching');
  };

  // Show login form
  const showLoginForm = () => {
    loginSection.hidden = false;
    registerSection.hidden = true;
  };

  // Show register form
  const showRegisterForm = () => {
    loginSection.hidden = true;
    registerSection.hidden = false;
  };

  // Update URL without page refresh
  const updateUrl = (isRegister) => {
    const url = new URL(window.location);
    if (isRegister) {
      url.searchParams.set('create_account', '1');
    } else {
      url.searchParams.delete('create_account');
    }
    history.replaceState({ isRegisterMode: isRegister }, '', url.toString());
  };

  // Switch to register form
  const switchToRegister = (e) => {
    e.preventDefault();
    showRegisterForm();
    animateVisibleSection(registerSection);
    updateUrl(true);
  };

  // Switch to login form
  const switchToLogin = (e) => {
    e.preventDefault();
    showLoginForm();
    animateVisibleSection(loginSection);
    updateUrl(false);
  };

  // Bind switch links
  switchToRegisterLinks.forEach(link => {
    link.addEventListener('click', switchToRegister);
  });

  switchToLoginLinks.forEach(link => {
    link.addEventListener('click', switchToLogin);
  });

  // Auto-open the forgotten-password modal on the recover deep-link / reset-success page.
  // (Trigger clicks are handled declaratively by <modal-opener data-modal="#forgotten">.)
  const openForgottenModal = () => {
    const forgottenModal = document.getElementById('forgotten');
    if (forgottenModal && typeof forgottenModal.show === 'function') {
      forgottenModal.show();
    }
  };

  if (window.location.hash === '#recover' || document.getElementById('reset_success')) {
    openForgottenModal();
  }

  clearLoginReturnUrlLinks.forEach((link) => {
    link.addEventListener('click', () => {
      window._erj_.clearReturnUrl();
    });
  });

  // ========== Password confirmation validation ==========
  const passwordInput = document.getElementById('register-password');
  const passwordConfirmInput = document.getElementById('register-password-confirm');
  const passwordMismatchError = document.getElementById('password-mismatch-error');

  if (passwordInput && passwordConfirmInput && passwordMismatchError) {
    const checkPasswordMatch = () => {
      const match = passwordInput.value === passwordConfirmInput.value;
      passwordMismatchError.style.display = match ? 'none' : 'block';
      return match;
    };

    passwordConfirmInput.addEventListener('blur', checkPasswordMatch);
    passwordConfirmInput.addEventListener('input', () => {
      if (passwordMismatchError.style.display === 'block') {
        checkPasswordMatch();
      }
    });

    // Prevent form submission if passwords don't match
    const registerForm = registerSection.querySelector('form');
    if (registerForm) {
      registerForm.addEventListener('submit', (e) => {
        if (!checkPasswordMatch()) {
          e.preventDefault();
        }
      });
    }
  }
});
